/**
 * config.js — Single source of truth for all environment URLs.
 *
 * Setup:
 *   cp .env.example .env          (first time only)
 *   Edit .env with your actual values
 *
 * The fallbacks below are for LOCAL DEVELOPMENT only.
 * For production: fill in .env.production before running npm run build.
 */

const config = {
  API_URL: process.env.REACT_APP_API_URL ,
  PATIENT_SERVICE_URL: process.env.REACT_APP_PATIENT_SERVICE_URL,
  MEDIA_URL: process.env.REACT_APP_MEDIA_URL ,
};

// Warn in dev if .env is missing — helps catch misconfiguration early
if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_URL) {
  console.warn(
    '[BI-RADS] REACT_APP_API_URL not set in .env — using fallback http://localhost:8000/api\n' +
    'Run: cp frontend/.env.example frontend/.env'
  );
}

export default config;
